import { InViewHookResponse } from 'react-intersection-observer';
import { ComponentType } from '@/types/cml-api';
import { elementTrackingId } from '@/app/(home-page)/_components/contants';
import { useDataLayerPush } from '@/app/_utils/use-datalayer-push';
import { cn } from '@/utils/cn';
import { INTERACTIFY_PARAM_KEY } from './constants';
import { useInteractifyParams } from './utils/use-vid-params';
import { IconPlay } from '../icons';
import { Webengage } from '../webengage';
interface Props {
  cover: string;
  title: string;
  slug: string;
  componentId?: string;
  sortKey?: string;
  index: number;
  inViewRef?: InViewHookResponse['ref'];
  isSingle?: boolean;
}
const SingleVideoItem = ({
  slug,
  componentId,
  sortKey,
  index,
  cover,
  title,
  inViewRef,
  isSingle = false
}: Props) => {
  const pushToDataLayer = useDataLayerPush();
  const {
    addInteractifyParam
  } = useInteractifyParams();
  const clickVideoHandler = (videoId: string, cover: string, itemIndex: number) => {
    addInteractifyParam(videoId, true);
    if (!sortKey || !componentId) return;
    const index = (itemIndex + 1)?.toString();
    const destinationUrl = `/videos?${INTERACTIFY_PARAM_KEY}=${videoId}`;
    pushToDataLayer({
      event: elementTrackingId,
      elementType: ComponentType.CarouselVideo,
      elementIndex: index,
      itemID: videoId,
      elementName: sortKey,
      destinationUrl,
      componentId: componentId,
      ImageUrl: cover
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.CarouselVideo,
      banner_name: sortKey,
      banner_index: index,
      url_destination: destinationUrl,
      item_id: videoId,
      component_id: componentId,
      image_url: cover
    });
  };
  return <div className={cn('bg-cover bg-center', {
    'keen-slider__slide !h-[150px] !min-w-[90px] !max-w-[90px] rounded lg:!h-[292px] lg:!min-w-44 lg:!max-w-44 lg:rounded-lg': !isSingle,
    'h-[264px] w-[158px] overflow-hidden rounded-lg lg:h-80 lg:w-48': isSingle
  })} style={{
    backgroundImage: `url(${cover})`
  }} key={slug} ref={inViewRef} data-sentry-component="SingleVideoItem" data-sentry-source-file="single-video-item.tsx">
            <button className={cn('relative flex h-full w-full flex-col justify-end', {
      'px-2 py-3 lg:px-3 lg:py-4': isSingle,
      'p-1 lg:p-3': !isSingle
    })} onClick={() => clickVideoHandler(slug, cover, index)}>
                <div className='absolute right-0 top-0 z-10 h-full w-full bg-gradient-to-t from-[rgba(0,0,0,0.5)_12.94%] to-[rgba(0,0,0,0.25)_100%]' />

                <IconPlay className={cn('absolute right-1/2 top-1/2 z-20 -translate-y-1/2 translate-x-1/2 rounded-full bg-surface-scrim-white lg:p-2.5', {
        'box-border h-14 w-14 p-1.5 lg:h-16 lg:w-16': isSingle,
        'box-content h-6 w-6 p-1 lg:h-11 lg:w-11': !isSingle
      })} data-sentry-element="IconPlay" data-sentry-source-file="single-video-item.tsx" />

                <span className={cn('z-20 line-clamp-2 shrink text-ellipsis text-right !text-white', {
        'text-title-16 lg:text-title-18': isSingle,
        'text-caption-10 lg:text-title-18': !isSingle
      })}>
                    {title}
                </span>
            </button>
        </div>;
};
export default SingleVideoItem;